import { Link } from "react-router-dom";
import { cn } from "@util/helpers";

import { COMMON_BUTTON_CSS, REMOVE_FOCUS_CSS } from "./constants";
import { getIconSrc } from "./helpers";
import SocialEmbedButtonFactory from "./SocialMediaButtonFactory";
import {
  ActionType,
  ButtonProps,
  ButtonSize,
  IconName,
  SocialMediaType,
} from "./types";

export default function Button({
  className = "",
  whichSocialMedia = SocialMediaType.facebook,
  shareUrl = "",
  actionType = ActionType.actionButton,
  icon = IconName.facebook,
  text,
  imgAlt = "icon",
  title = "",
  onClick,
  buttonSize = ButtonSize.small,
  iconSize = 24,
}: ButtonProps) {
  const commonCss = `${REMOVE_FOCUS_CSS} ${COMMON_BUTTON_CSS}`;

  switch (actionType) {
    case ActionType.shareButton:
      return (
        <SocialEmbedButtonFactory
          commonCss={commonCss}
          whichSocialMedia={whichSocialMedia}
          shareUrl={shareUrl}
          className={className}
          title={title}
          iconSize={iconSize}
          buttonSize={buttonSize}
        />
      );

    case ActionType.linkButton:
      return (
        <Link
          className={cn(
            {
              "aspect-square": icon && !text,
            },
            commonCss,
            className
          )}
          to={shareUrl}
          target="_blank"
          rel="noreferrer"
          referrerPolicy="strict-origin-when-cross-origin"
          title={icon}
          data-testid={`link-button-${icon}`}
          aria-label={icon}
          data-size={buttonSize}
        >
          {icon ? (
            <img
              src={getIconSrc(icon)}
              width={iconSize}
              height={iconSize}
              alt={imgAlt}
            />
          ) : null}
        </Link>
      );

    case ActionType.actionButton:
    default:
      return (
        <button
          className={cn(
            commonCss,
            {
              "aspect-square": icon && !text,
            },
            className
          )}
          onClick={onClick}
          data-size={buttonSize}
        >
          {icon ? (
            <img
              src={getIconSrc(icon)}
              width={iconSize}
              height={iconSize}
              alt={imgAlt}
            />
          ) : null}

          {text ? <p>{text}</p> : null}
        </button>
      );
  }
}
